
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
// import FeatherIcon from "feather-icons-react";
import { useUser } from "../../core/context/user";
import { loadBtwLastUrl } from "../../core/btw-last-url";
const Sidebar = (props) => {

  const { isCurrentUserAdmin, userData } = useUser();
  const isBtwPartner = !!userData?.btwPartnerEnabled;

  // const { getUserRoles } = useUser();

  const location = useLocation();
  let pathname = location.pathname;

  // Onthoudt laatste BTW Batterij URL (board vs lijst + filters) zodat sidebar-
  // klik teruggaat naar wat de admin het laatst zag. Reageert op cross-tab
  // (`storage`) en same-tab (`btw:lastUrl`) updates.
  const [btwLastUrl, setBtwLastUrl] = useState(loadBtwLastUrl());
  useEffect(() => {
    const refresh = () => setBtwLastUrl(loadBtwLastUrl());
    window.addEventListener("storage", refresh);
    window.addEventListener("btw:lastUrl", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("btw:lastUrl", refresh);
    };
  }, []);

  useEffect(() => {
    document.querySelector(".main-wrapper").classList.remove("slide-nav");
    document.querySelector(".sidebar-overlay").classList.remove("opened");
    document.querySelector(".sidebar-overlay").onclick = function () {
      this.classList.remove("opened");
      document.querySelector(".main-wrapper").classList.remove("slide-nav");
    };
  }, [pathname]);


  return (
    <>
      { isCurrentUserAdmin() ?
        <div
        className={`sidebar index-4`}id="sidebar">
        <div className="slimScrollDiv">
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
            >
              <ul className="lg:mt-[50px]">
                <li className="submenu-open">
                  <ul>
                      <li className={pathname.includes("dashboard") ? "active" : ""}>
                        <Link to="/panel/admin/dashboard">
                          <span>Dashboard</span>
                        </Link>
                      </li>

                      <li className="menu-section-title">Subsidie-aanvragen</li>
                      <li className={pathname.includes("eia-overzicht") ? "active" : ""}>
                        <Link to="/panel/admin/eia-overzicht">
                          <span>EIA</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("eia-zon-overzicht") ? "active" : ""}>
                        <Link to="/panel/admin/eia-zon-overzicht">
                          <span>EIA Zon</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("isde-overzicht") ? "active" : ""}>
                        <Link to="/panel/admin/isde-overzicht">
                          <span>ISDE</span>
                        </Link>
                      </li>

                      <li className="menu-section-title">BTW-teruggave</li>
                      <li className={pathname.includes("btw-batterij") && !pathname.includes("btw-batterij-instellingen") ? "active" : ""}>
                        <Link to={btwLastUrl}>
                          <span>BTW Batterij</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("partner-facturen") ? "active" : ""}>
                        <Link to="/panel/admin/partner-facturen">
                          <span>Partner-facturen</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("btw-batterij-instellingen") ? "active" : ""}>
                        <Link to="/panel/admin/btw-batterij-instellingen">
                          <span>Statussen</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("btw-labels") ? "active" : ""}>
                        <Link to="/panel/admin/btw-labels">
                          <span>Labels</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("btw-email-templates") ? "active" : ""}>
                        <Link to="/panel/admin/btw-email-templates">
                          <span>Mail-templates</span>
                        </Link>
                      </li>

                      <li className="menu-section-title">Administratie</li>
                      <li className={pathname.includes("klanten") ? "active" : ""}>
                        <Link to="/panel/admin/klanten">
                          <span>Klanten</span>
                        </Link>
                      </li>
                      <li className={pathname.includes("financieel") ? "active" : ""}>
                        <Link to="/panel/admin/financieel">
                          <span>Financieel</span>
                        </Link>
                      </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
        :
        <div
        className={`sidebar index-4 ${pathname.includes("/index-three") ? "d-none" : ""
          }`}
        id="sidebar"
      >

        <div className="slimScrollDiv">
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
            >
              <ul className="lg:mt-[50px]">
                <li className="submenu-open">
                  <ul>
                    {(
                      <li
                        className={
                          pathname.includes("dashboard") ? "active" : ""
                        }
                      >
                        <Link to="/panel/customer/dashboard" >
                          <span>Dashboard</span>
                        </Link>
                      </li>
                    )}
                    {(
                      <li
                      className={
                        pathname.includes("eia-aanvragen") ? "active" : ""
                      }
                      >
                        <Link
                         
                          to="/panel/customer/eia-aanvragen"
                        >
                          <span>EIA Aanvragen</span>
                        </Link>
                      </li>
                    )}

                    {(
                      <li
                        className={pathname.includes("eia-zon-aanvragen") ? "active" : ""}
                      >
                        <Link
                          to="/panel/customer/eia-zon-aanvragen"
                        >
                          <span>EIA Zon Aanvragen</span>
                        </Link>
                      </li>
                    )}

                    {(
                      <li
                        className={ pathname.includes("isde-aanvragen") ? "active" : ""}
                      >
                        <Link
                          to="/panel/customer/isde-aanvragen"
                        >
                          <span>ISDE Aanvragen</span>
                        </Link>
                      </li>
                    )}



                    {isBtwPartner && (
                      <li
                        className={
                          pathname.includes("btw-teruggaves") ? "active" : ""
                        }
                      >
                        <Link to="/panel/customer/btw-teruggaves">
                          <span>BTW Teruggaves</span>
                        </Link>
                      </li>
                    )}

                    {(
                      <li
                        className={ pathname.includes("facturen") ? "active" : ""}
                      >
                        <Link
                          to="/panel/customer/facturen"
                        >
                          <span>Facturen</span>
                        </Link>
                      </li>
                    )}


                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
      }
    </>
  );
};

export default Sidebar;
